import { render } from "./ListLibroMayorGeneral.vue?vue&type=template&id=3b6a4426"
import script from "./ListLibroMayorGeneral.vue?vue&type=script&lang=js"
export * from "./ListLibroMayorGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__